import React from 'react';
import PropTypes from 'prop-types';

import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import BreadcrumbsDropdown from '../../components/Breadcrumbs/BreadcrumbsDropdown';
import CompanyHeader from '../../components/Breadcrumbs/CompanyHeader';
import PublisherHeader from '../../components/Breadcrumbs/PublisherHeader';
import AppHeader from '../../components/Breadcrumbs/AppHeader';
import AppList from '../../components/Breadcrumbs/AppList';
import CompanyList from '../../components/Breadcrumbs/CompanyList';

const emptyArray = [];

const PageBreadcrumbs = ({ company, publisher, app }) => (
  <Breadcrumbs>
    {company?.active?.name && (
      <BreadcrumbsDropdown
        header={CompanyHeader}
        active={company.active}
        dropList={CompanyList}
        list={company.list || emptyArray}
        scrollableTarget="breadcrumbs-company"
      />
    )}
    {publisher?.active?.name && (
      <BreadcrumbsDropdown
        header={PublisherHeader}
        active={publisher.active}
        dropList={CompanyList}
        list={publisher.list || emptyArray}
        scrollableTarget="breadcrumbs-publisher"
      />
    )}
    {app?.active?.name && (
      <BreadcrumbsDropdown
        header={AppHeader}
        active={app.active}
        dropList={AppList}
        list={app.list || emptyArray}
      />
    )}
  </Breadcrumbs>
);

PageBreadcrumbs.propTypes = {
  company: PropTypes.object,
  publisher: PropTypes.object,
  app: PropTypes.object,
};
export default PageBreadcrumbs;
